import React from "react";

export default function timeAgo(dateString) {
    const now = new Date();
    const then = new Date(dateString);
    const secondsAgo = Math.floor((now - then) / 1000);
  
    const intervals = [
      { label: 'year', seconds: 60 * 60 * 24 * 365 },
      { label: 'month', seconds: 60 * 60 * 24 * 30 },
      { label: 'day', seconds: 60 * 60 * 24 },
      { label: 'hour', seconds: 60 * 60 },
      { label: 'minute', seconds: 60 },
    ];
  
    for (const interval of intervals) {
      const count = Math.floor(secondsAgo / interval.seconds);
      if (count > 0) {
        const suffix = count === 1 ? '' : 's';
        return `${count} ${interval.label}${suffix} ago`;
      }
    }
    return 'just now';
  }